import { newSpecPage } from '@stencil/core/testing';
import { LabDsTextField } from './lab-ds-text-field';

describe('v4text-field', () => {
  it('renders', async () => {
    const page = await newSpecPage({
      components: [LabDsTextField],
      html: `<lab-ds-text-field value='oi' label-icon="person"/>`,
    });
    expect(page.root).toEqualHtml(`
    <lab-ds-text-field label-icon="person" value="oi">
      <mock:shadow-root>
       <div class="default false v4-input">
        <span class="title-text"></span>
         <div class="input-helper">
           <div class="input-icon">
             <lab-ds-icon-not-selectable class="icon left" icon="person" size="small"></lab-ds-icon-not-selectable>
             <input class="input-field" placeholder="" type="text" value="oi">
             <lab-ds-icon-not-selectable class="icon right" icon="" size="small"></lab-ds-icon-not-selectable>
           </div>
         </div>
       </div>
      </mock:shadow-root>
     </lab-ds-text-field>
  `);
  });
  it('renders with default values', async () => {
    const page = await newSpecPage({
      components: [LabDsTextField],
      html: `<lab-ds-text-field value='oi'/>`,
    });
    expect(page.root).toEqualHtml(`
      <lab-ds-text-field value="oi">
      <mock:shadow-root>
       <div class="default false v4-input">
        <span class="title-text"></span>
         <div class="input-helper">
           <div class="input-icon">
             <input class="input-field" placeholder="" type="text" value="oi">
             <lab-ds-icon-not-selectable class="icon right" icon="" size="small"></lab-ds-icon-not-selectable>
           </div>
         </div>
       </div>
      </mock:shadow-root>
     </lab-ds-text-field>
    `);
  });
});
